<div class="mini-vertical-price-review">
  <div class="width_wrapper inner_seo_page_component_container">
    @if (hasPrices || hasReviews) {
      <div class="price-review-container">
        <!-- Price Average Section -->
        @if (hasPrices) {
          <div class="price-section">
            <app-price-average
              [priceLow]="priceLow"
              [priceMedium]="priceMedium"
              [priceHigh]="priceHigh"
              [title]="priceGuideTitle"
              [priceGuideLink]="priceGuideLink"
            ></app-price-average>
          </div>
        }

        <!-- Review Overview Section -->
        @if (hasReviews) {
          <div class="review-section">
            <app-review-overview
              [tasks]="tasks"
              [reviewCount]="reviewCount"
              [verticalName]="miniVertical?.cat || miniVertical.task"
            ></app-review-overview>
          </div>
        }
      </div>
    }
  </div>
</div>
